import { put, call, fork, all, takeLatest, select } from "redux-saga/effects";
import * as healthInsuranceCardTypes from "~/store/payment/paymentType";
import {
  getMedicalBill
} from "~/api/umc/healthInsuranceCard";



function* getMedicalBillByHospitalIdWorker({ data }) {
  try {
    const { info } = yield select(state => state.user);
    const params = {
      user_id: info.user_id,
      access_token: info.access_token
    };
    const response = yield call(getMedicalBill, data.base_url, params);
    if (response.error_code) throw new Error("Server error");
    yield put({
      type: healthInsuranceCardTypes.GET_MEDICAL_BILL_BY_HOSPITALID_SUCCESS,
      data: response.data
    });
  } catch (error) {
    yield put({
      type: healthInsuranceCardTypes.GET_MEDICAL_BILL_BY_HOSPITALID_FAILURE,
      error
    });
  }
}

function* watchRequestHealthInsuranceCard() {
  yield takeLatest(
    healthInsuranceCardTypes.GET_MEDICAL_BILL_BY_HOSPITALID_REQUEST,
    getMedicalBillByHospitalIdWorker
  );
}

export default function* root() {
  yield all([fork(watchRequestHealthInsuranceCard)]);
}
